import React from 'react';
import {
  makeStyles,
  Container,
  Paper,
  Box,
  Button,
} from '@material-ui/core';
import MoodBadIcon from '@material-ui/icons/MoodBad';
import redirectLinks from '../../../constants/redirectLinks';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(8),
    lineHeight: '2',
  },
  root: {
    padding: theme.spacing(2),
  },
  iconSize: {
    'font-size': '65px',
  },
}));

export default function SystemError() {
  const classes = useStyles();
  const onClick = () => {
    window.location.href = redirectLinks.BASE;
  };

  return (
    <div>
      <Container className={classes.container}>
        <Paper elevation={0} className={classes.root}>
          <Box fontWeight="fontWeightBold" fontSize={{ xs: 22, sm: 30 }} textAlign="center">
            一時的なエラーが発生しました
          </Box>
          <Box mt={2} textAlign="center">
            <MoodBadIcon className={classes.iconSize} />
          </Box>
          <Box mt={2} textAlign="center" fontSize={{ xs: 14, sm: 18 }}>
            問題が発生したため、ページを表示できません。
            <br />
            恐れ入りますが、しばらく時間を置いてから再度お試しください。
          </Box>
          <Box textAlign="center" mt={3}>
            <Button variant="contained" color="primary" onClick={onClick}>TOPへ戻る</Button>
          </Box>
        </Paper>
      </Container>
    </div>
  );
}
